import { CommonModule, NgFor, NgIf } from '@angular/common'
import {
  AfterContentInit,
  ChangeDetectorRef,
  Component,
  Input,
  ViewChild,
  ViewEncapsulation
} from '@angular/core'
import { FormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { KENDO_BUTTONS } from '@progress/kendo-angular-buttons'
import { GridComponent, GridDataResult, KENDO_GRID } from '@progress/kendo-angular-grid'
import { KENDO_INPUTS } from '@progress/kendo-angular-inputs'
import { KENDO_LABELS } from '@progress/kendo-angular-label'
import { State } from '@progress/kendo-data-query'
import * as CryptoJS from 'crypto-js'
import { Observable } from 'rxjs'
import { environment } from '../../../../environments/environment'
const createFormGroup = (dataItem) =>
  new UntypedFormGroup({
    blotterId: new UntypedFormControl(dataItem.blotterId),
    comment: new UntypedFormControl(dataItem.comment),
    blotterCommentId: new UntypedFormControl(dataItem.blotterCommentId),
    modifiedDate: new UntypedFormControl(dataItem.modifiedDate),
    modifiedBy: new UntypedFormControl(dataItem.modifiedBy),
  })
@Component({
    selector: 'gd-comment',
    template: `
    <div class="spacing">
      <div>
        <button kendoButton 
          *ngIf="newtransaction"
          [rounded]="rounded"
          [size]="small"
          (click)="addBlankRow($event)"
        >
          Add new comment box
        </button>
      </div>
      <div *ngFor="let obj of field.value; let i = index">
        <span style="margin-left:-10px">{{ i + 1 }}.</span>
       <textarea
  #both
  [(ngModel)]="obj.comment"
  (input)="commentInput()"
  placeholder="Add a comment here"
 [rows]="5"
          [cols]="43"
  class=" rounded-lg border border-gray-300 dark:border-gray-600
         bg-white dark:bg-gray-800 text-sm text-gray-900 dark:text-gray-100
         placeholder-gray-400 dark:placeholder-gray-500
         focus:ring-2 focus:ring-primary-500 focus:border-primary-500
         p-3 shadow-sm transition duration-150 ease-in-out
         resize-both overflow-auto"
></textarea>
        
        <div>&nbsp;</div>
      </div>
      <!--
      <kendo-grid
        [data]="field.value"
        [style.height.%]="100"
        (edit)="editHandler($event)"
        (cellClick)="cellClickHandler($event)"
        (cellClose)="cellCloseHandler($event)"
        (cancel)="cancelHandler($event)"
        (remove)="removeHandler($event)"
        (add)="addHandler($event)"
        (save)="saveHandler($event)"
        [height]="410"
        [detailExpand]="shouldExpandFirstRow()"
      >
        <ng-template kendoGridToolbarTemplate style="float:right">
          <button kendoGridAddCommand #buttonSearch>Add new</button>
        </ng-template>
        <kendo-grid-column field="comment" title="" width="420">
          <ng-template
            kendoGridEditTemplate
            let-column="column"
            let-formGroup="formGroup"
            let-isNew="isNew"
          >
            <textarea
              rows="7"
              cols="100%"
              #input
              [formControl]="formGroup.get(column.field)"
            >
            </textarea>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
          field="modifiedDate"
          title="ModifiedDate"
          [hidden]="!isHidden()"
        >
          <ng-template let-column kendoGridCellTemplate>
            {{ column.modifiedDate | date : 'short' }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
          field="modifiedBy"
          title="ModifiedBy"
          [hidden]="!isHiddenby()"
        >
        </kendo-grid-column>
        <kendo-grid-command-column title="">
          <ng-template kendoGridCellTemplate let-isNew="isNew">
            <button kendoGridSaveCommand>
              {{ isNew ? 'Add' : 'Update' }}
            </button>
            <button kendoGridCancelCommand>
              {{ isNew ? 'Discard changes' : 'Cancel' }}
            </button>
          </ng-template>
        </kendo-grid-command-column>
      </kendo-grid> -->
    </div>
  `,
    styleUrls: ['./globalform.css'],
    imports: [
      CommonModule,
        NgIf,
        NgFor,
        FormsModule,
        KENDO_GRID,
         KENDO_BUTTONS,
         KENDO_INPUTS, KENDO_LABELS
    ],
    encapsulation: ViewEncapsulation.None,
    styles: [
    `
      .wrapper {
        display: flex;
        justify-content: space-evenly;
      }
    `,
  ],
})
export class CommentListComponent implements AfterContentInit {
  arrayToGet
  @Input() field: any = {
    value: [
      {
        blotterCommentId: 0,
        blotterId: 0, // Assign the constant blotterId value
        comment: '',
      },
    ],
  }
  /*   @Input() field: any */
  @Input() form: UntypedFormGroup
  @ViewChild(GridComponent) grid!: GridComponent
  public formGroup: UntypedFormGroup
  public hiddenColumns: Date[] = []
  public view: Observable<GridDataResult>
  private editedRowIndex: number
  private data: any[] = []
  private createdItems: any[] = []
  public blotId: number
  public newtransaction = false
  public gridState: State = {
    sort: [],
    skip: 0,
    take: 10,
  }
  constructor(
    private cdr: ChangeDetectorRef,
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
  ) {
    if (this.route.snapshot.queryParams['Rview']) {
      // QueryString Review here
      this.route.queryParams.subscribe((params) => {
        const getblotterClient = CryptoJS.AES.decrypt(
          params['Rview'],
          `${environment.securepw}`,
        ).toString(CryptoJS.enc.Utf8)
        this.blotId = Number(getblotterClient)
      })
      this.newtransaction = true
    } else {
      this.newtransaction = false
    }
    if (this.blotId === undefined) {
      this.blotId
    }
  }

  addBlankRow(event: Event) {
    event.preventDefault()
    this.field.value.push({
      comment: '',
    })
  }

  ngAfterContentInit(): void {
    if (this.field.value && this.field.value.length > 0) {
      // Iterate over array elements
      for (const element of this.field.value) {
        // Check if the 'comment' field is not blank
        if (element.comment.trim() !== '') {
          // Do something if the comment is not blank
        }
      }
    } else {
      this.field.value.push({
        comment: '',
      })
    }
  }

  commentInput() {
    this.form.markAsDirty()
  }

  /*  private initializeForm() {
    if (this.formGroup && this.formGroup.get('comments') instanceof FormArray) {
      const commentsArray = this.formGroup.get('comments') as FormArray
      if (this.field.value.length === 0) {
        // If field.value is empty, push an initial item to the array
        commentsArray.push(
          this.formBuilder.group({
            comment: [''], // Set default value or leave it empty
            blotterCommentId: [0], // Default value for blotterCommentId
            blotterId: this.blotId, // Constant value for blotterId
            // Add other form controls as needed
          }),
        )
      } else {
        // Initialize form controls based on existing data
        this.field.value.forEach((comment: any) => {
          commentsArray.push(
            this.formBuilder.group({
              comment: [comment.comment],
              blotterCommentId: [comment.blotterCommentId],
              blotterId: this.blotId,
              // Add other form controls as needed
            }),
          )
        })
      }
    } else {
      const commentsArray = this.formGroup.get('comments') as FormArray
    }

    if (!Array.isArray(this.field.value)) {
      // If field.value is not an array, initialize it as an empty array
      this.field.value = []
    }
  } */

  shouldExpandFirstRow(): boolean {
    return this.field.value.length === 0
  }

  public isHidden() {
    const checkval = this.field.value.find((x) => x.ModifiedDate !== null)
    return checkval
  }
  public isHiddenby() {
    const checkval = this.field.value.find((x) => x.ModifiedBy !== null)
    return checkval
  }
  public isHiddenbutton() {
    const checkval = this.field.value.find((x) => x.comment !== null)
    return checkval
  }
  public editHandler({ sender, rowIndex, dataItem }) {
    this.closeEditor(sender)

    this.form = createFormGroup(dataItem)

    this.editedRowIndex = rowIndex

    sender.editRow(rowIndex, this.form)
  }

  public cancelHandler({ sender, rowIndex }) {
    this.closeEditor(sender, rowIndex)
  }
  private closeEditor(grid, rowIndex = this.editedRowIndex) {
    grid.closeRow(rowIndex)
    this.editedRowIndex = undefined
    this.form = undefined
  }
  public createFormGroup(): UntypedFormGroup {
    return this.formBuilder.group({
      blotterCommentId: 0,
      blotterId: this.blotId,
      comment: ['', Validators.required],
    })
  }

  public addHandler() {
    this.createFormGroup()
  }
  public cellCloseHandler(args: any) {
    const { formGroup, dataItem } = args
    if (!formGroup.valid) {
      args.preventDefault()
    } else if (formGroup.dirty) {
      this.assignValues(dataItem, formGroup.value)
    }
  }
  public assignValues(target: any, source: any): void {
    Object.assign(target, source)
  }
  public saveHandler({ sender, formGroup, rowIndex }) {
    if (formGroup.valid) {
      this.field.value.push(formGroup.value)
      sender.closeRow(rowIndex)
      this.form.value.push(formGroup.value)
    }
  }
  public removeHandler({ dataItem }): void {
    this.remove(dataItem)
  }
  public remove(blotId: any): void {
    const index = this.data.findIndex(
      ({ blotterCommentId }) => blotterCommentId === blotId.blotId,
    )
    this.data.splice(index, 1)
  }
  public create(item: any): void {
    this.createdItems.push(item)
    this.data.unshift(item)
    this.data
  }
}
